/**
 * The research-led hero copy on the inline-start side: eyebrow, the two-line
 * headline, the support line, then the call to action with its
 * availability note and the reassurance beneath a hairline.
 */

import type { ReactNode } from 'react';

import type { PublicEarlyAccessCopy } from './copy.js';
import { EarlyAccessCTA } from './EarlyAccessCTA.js';

export function HeroContent({
  copy,
  onRequestAccess,
}: {
  readonly copy: PublicEarlyAccessCopy;
  readonly onRequestAccess: (from: HTMLElement) => void;
}): ReactNode {
  return (
    <div className="cs-hero-copy">
      <p className="cs-eyebrow">
        <span className="cs-eyebrow-dot" aria-hidden="true" />
        <span>{copy.eyebrow}</span>
      </p>
      <h1 className="cs-h1">
        <span className="cs-line">{copy.h1a}</span>
        <span className="cs-line">{copy.h1b}</span>
      </h1>
      <p className="cs-support">{copy.support}</p>
      <div className="cs-cta-block">
        <EarlyAccessCTA copy={copy} onOpen={onRequestAccess} />
        <p className="cs-cta-note">{copy.ctaNote}</p>
      </div>
    </div>
  );
}
